<template>
    <div id="home">
        <el-scrollbar :class="isCollapse?'menu_hide rightSide':'rightSide'">
            <el-main>
                <div class="floatLayerDiv">
                    <img src="~assets/img/indebg.png" class="mapPic" alt="Failed to load image."/>
                </div>
                <div class="parkSelect">
                    <el-select v-model="ParkSelectvalue" :placeholder="$t('el.select.placeholder')">
                        <el-option v-for="item in ParkSelectoptions"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="ParkEDiv">
                    <el-card class="el-card box-card ParkE">
                        <div class="el-card__header">
                            <a :title="$t('viewDetails')">{{ $t('Headquarters') }}</a>
                            <el-button style="float: right; padding: 3px 0" type="text" :title="$t('powerConsumption')"><i
                                    class="el-icon-more-outline"></i></el-button>
                        </div>
                        <div class="el-card__body">
                            <ul>
                                <li>
                                    <small>{{ $t('LastConsumption') }}</small>
                                    <span><strong>{{lasttotal}}</strong>{{ $t('degree') }}</span>
                                </li>
                                <li>
                                    <small>{{ $t('electricityConsumption') }}</small>
                                    <span><strong>{{curtatol}}</strong>{{ $t('degree') }}</span>
                                </li>
                                <li>
                                    <small>{{ $t('averageConsumption') }}</small>
                                    <small>-：</small>
                                    <span><strong>{{lastavgday}}</strong>{{ $t('degree') }}</span>
                                </li>
                                <li>
                                    <small>{{$t('consumption')}}</small>
                                    <span><strong>{{curday}}</strong>{{ $t('degree') }}</span>
                                </li>
                            </ul>
                        </div>
                    </el-card>
                </div>
                <div class="packStateDiv">
                    <div class="StateDiv" @click="toWarning" :title="$t('viewDetails')">
                        <span v-if="elcNotifCount>0" style="color:red">{{elcNotifCount}}</span>
                        <span v-else style="color:white">{{elcNotifCount}}</span>
                        <h6 style="color:white">{{$t('PowerSafetyAlarm')}}</h6>

                    </div>
                    <div class="StateDiv" @click="toWarning" :title="$t('viewDetails')">
                        <span v-if="thmNotifCount>0" style="color:red">{{thmNotifCount}}</span>
                        <span v-else style="color:white">{{thmNotifCount}}</span>
                        <h6 style="color:white">{{ $t('environmental') }}</h6>
                    </div>
                </div>
                <div class="floatLayerDiv">
                    <el-button  v-popover:popover1 class="floatBtn" style="top: 34%;left: 10%;">{{ $t('Experimental') }}</el-button>
                    <el-popover v-show="JSON.stringify(data1)!='{}'" ref="popover1" placement="top" v-model="showfloat1" trigger="hover">
                        <div class="floatDiv">
                            <h5>
                              {{ $t('Experimental') }}
                                <el-button style="float: right; padding: 3px 0" type="text" :title="$t('DetailsView')"
                                           @click="showDetail('1')">
                                    <i class="el-icon-more-outline"></i>
                                </el-button>
                            </h5>
                            <!-- <ul>
                                <li>
                                    <span><small>上月电量：</small><strong></strong>度</span>
                                </li>
                                <li>
                                    <span><small>本月电量：</small><strong>0</strong>度</span>
                                </li>
                                <li>
                                    <span><small>上月日均电量：</small><strong>0</strong>度</span>
                                </li>
                                <li>
                                    <span><small>当日电量：</small><strong>0</strong>度</span>
                                </li>
                            </ul> -->
                        </div>
                    </el-popover>
                    <el-button  v-popover:popover2 class="floatBtn" style=" top: 45%; left: 34%;">B3{{ $t('ComprehensiveBuilding') }}</el-button>
                    <el-popover v-show="JSON.stringify(data3)!='{}'"  ref="popover2" placement="top" v-model="showfloat2" trigger="hover">
                        <div class="floatDiv">
                            <h5>
                                B3{{ $t('ComprehensiveBuilding') }}
                                <el-button style="float: right; padding: 3px 0" type="text" :title="$t('DetailsView')"
                                           @click="showDetail('3')">
                                    <i class="el-icon-more-outline"></i>
                                </el-button>
                            </h5>
                            <ul>
                                <li>
                                    <span><small>{{ $t('LastConsumption') }}</small><strong>{{data3.electricQuantityPlan}}</strong>{{ $t('degree') }}</span>
                                </li>
                                <li>
                                    <span><small>{{ $t('electricityConsumption') }}</small><strong>{{data3.electricQuantity}}</strong>{{ $t('degree') }}</span>
                                </li>
                                <li>
                                    <span><small>上月日均电量：</small><strong>{{data3.avgElectricQuantity}}</strong>{{ $t('degree') }}</span>
                                </li>
                                <li>
                                    <span><small>{{$t('consumption')}}</small><strong>{{data3.current_ElectricQuantity}}</strong>{{ $t('degree') }}</span>
                                </li>
                            </ul>
                        </div>
                    </el-popover>

                    <el-button  v-popover:popover3 class="floatBtn" style=" top: 52%; left: 70%;">B6{{$t('ExperimentBuilding')}}</el-button>
                    <el-popover v-show="JSON.stringify(data6)!='{}'"  ref="popover3" placement="top" v-model="showfloat3" trigger="hover">
                        <div class="floatDiv">
                            <h5>
                                B6{{$t('ExperimentBuilding')}}
                                <el-button style="float: right; padding: 3px 0" type="text" :title="$t('DetailsView')"
                                           @click="showDetail('6')">
                                    <i class="el-icon-more-outline"></i>
                                </el-button>
                            </h5>
                            <ul>
                                <li>
                                    <span><small>{{ $t('LastConsumption') }}</small><strong>{{data6.electricQuantityPlan}}</strong>{{ $t('degree') }}</span>
                                </li>
                                <li>
                                    <span><small>{{ $t('electricityConsumption') }}</small><strong>{{data6.electricQuantity}}</strong>{{ $t('degree') }}</span>
                                </li>
                                <li>
                                    <span><small>上月日均电量：</small><strong>{{data6.avgElectricQuantity}}</strong>{{ $t('degree') }}</span>
                                </li>
                                <li>
                                    <span><small>{{ $t('consumption') }}</small><strong>{{data6.current_ElectricQuantity}}</strong>{{ $t('degree') }}</span>
                                </li>
                            </ul>
                        </div>
                    </el-popover>

                    <el-button  v-popover:popover4 class="floatBtn" style=" top: 22%; left: 20%;">B4{{$t('ExperimentBuilding')}}</el-button>
                    <el-popover v-show="JSON.stringify(data4)!='{}'"  ref="popover4" placement="top" v-model="showfloat4" trigger="hover">
                        <div class="floatDiv">
                            <h5>
                                B4{{$t('ExperimentBuilding')}}
                                <el-button style="float: right; padding: 3px 0" type="text" :title="$t('DetailsView')"
                                           @click="showDetail('4')">
                                    <i class="el-icon-more-outline"></i>
                                </el-button>
                            </h5>
                            <!-- <ul>
                                <li>
                                    <span><small>上月电量：</small><strong>3,568,212</strong>度</span>
                                </li>
                                <li>
                                    <span><small>本月电量：</small><strong>1,295,481</strong>度</span>
                                </li>
                                <li>
                                    <span><small>上月日均电量：</small><strong>118,958</strong>度</span>
                                </li>
                                <li>
                                    <span><small>当日电量：</small><strong>68,595</strong>度</span>
                                </li>
                            </ul> -->
                        </div>
                    </el-popover>

                    <el-button   v-popover:popover5 class="floatBtn" style=" top: 12%; left: 35%;">B2{{$t('ExperimentBuilding')}}</el-button>
                    <el-popover v-show="JSON.stringify(data2)!='{}'" ref="popover5" placement="top" v-model="showfloat5" trigger="hover">
                        <div class="floatDiv">
                            <h5>
                                B2{{$t('ExperimentBuilding')}}
                                <el-button style="float: right; padding: 3px 0" type="text" :title="$t('DetailsView')"
                                           @click="showDetail('2')">
                                    <i class="el-icon-more-outline"></i>
                                </el-button>
                            </h5>
                            <!-- <ul>
                                <li>
                                    <span><small>上月电量：</small><strong>3,568,212</strong>度</span>
                                </li>
                                <li>
                                    <span><small>本月电量：</small><strong>1,295,481</strong>度</span>
                                </li>
                                <li>
                                    <span><small>上月日均电量：</small><strong>118,958</strong>度</span>
                                </li>
                                <li>
                                    <span><small>当日电量：</small><strong>68,595</strong>度</span>
                                </li>
                            </ul> -->
                        </div>
                    </el-popover>
                </div>
            </el-main>
        </el-scrollbar>

        <el-dialog :title="$t('MonitoringDistributionMap')" :visible.sync="dialogBuilding" width="80%" top="5vh">
            <el-row>
                <el-col :span="4">
                    <div class="buildingList">
                        <div class="buildingListDetail">
                            <h5>{{ $t('JinqiaoHeadquarters') }}</h5>
                            <div>
                                <el-radio v-model="radio1" label="1" border>{{ $t('BuildingB1') }}</el-radio>
                                <el-radio v-model="radio1" label="2" border>{{ $t('BuildingB2') }}</el-radio>
                                <el-radio v-model="radio1" label="3" border>{{ $t('BuildingB3') }}</el-radio>
                                <el-radio v-model="radio1" label="4" border>{{ $t('BuildingB4') }}</el-radio>
                                <el-radio v-model="radio1" label="6" border>{{$t('BuildingB6')}}</el-radio>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="20">
                    <div class="buildingDetail">
                        <div>
                            <div class="title">
                                <h4 class="fl">{{ $t('Experimental') }}</h4>
                                <p class="fr">
                                    <span>{{ $t('MonthlyElectricityConsumption') }}({{ $t('degree') }})：<strong>29,382</strong></span>
                                    <span>{{ $t('DailyElectricityConsumption') }}({{ $t('degree') }})：<strong>4,345</strong></span>
                                </p>
                                <div class="clear"></div>
                            </div>
                            <el-row class="con">
                                <el-col :span="6">
                                    <div class="buildimg">
                                        <img src="~assets/img/building1.jpg" alt="Failed to load image"/>
                                    </div>
                                </el-col>
                                <el-col :span="18" style="padding-left:20px">
                                    <img src="~assets/img/Circuitdiagram1.jpg" alt="Failed to load image"/>
                                    <el-table :data="tableData1"
                                              @header-click="equipmentVisible=true"
                                              style="width: 100%">
                                        <el-table-column prop="YM"
                                                         label="">
                                        </el-table-column>
                                        <el-table-column prop="Ename1"
                                                         :label="$t('TransformerB3-1')">
                                        </el-table-column>
                                        <el-table-column prop="Ename2"
                                                         :label="$t('TransformerB3-3')">
                                        </el-table-column>
                                        <el-table-column prop="Ename3"
                                                         :label="$t('TransformerB3-2')">
                                        </el-table-column>
                                        <el-table-column prop="Ename4"
                                                         :label="$t('TransformerB3-4')">
                                        </el-table-column>
                                    </el-table>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-dialog width="80%" top="10vh"
                       :title="$t('EquipmentPowerConsumption')"
                       :visible.sync="equipmentVisible"
                       append-to-body>
                <div>
                    <div class="buildimg">
                        <img src="~assets/img/Circuitdiagram2.jpg"  alt="Failed to load image" />
                    </div>
                    <el-table :data="tableData2"
                              style="width: 100%">
                        <el-table-column prop="YM"
                                         label="">
                        </el-table-column>
                        <el-table-column prop="Ename1"
                                         :label="$t('F03-d')">
                        </el-table-column>
                        <el-table-column prop="Ename2"
                                         :label="$t('F03-FCarrierFreezer')">
                        </el-table-column>
                        <el-table-column prop="Ename3"
                                         :label="$t('F01-ECarrierFreezer')">
                        </el-table-column>
                        <el-table-column prop="Ename4"
                                         :label="$t('F01-FCarrierFreezer')">
                        </el-table-column>
                        <el-table-column prop="Ename5"
                                         :label="$t('TransformerTotal')">
                        </el-table-column>
                    </el-table>
                </div>
            </el-dialog>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogBuilding = false">{{ $t('Close') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {GetNotifCount, GetDBRepAPIUrlInfo, GetElectricQuantityData} from '../../../api/api'
    import {mapState} from 'vuex';

    export default {

        name: "Home",
        data() {
            return {
                showfloat1: false,
                showfloat2: false,
                showfloat3: false,
                showfloat4: false,
                showfloat5: false,
                dialogBuilding: false,
                equipmentVisible: false,
                elcNotifCount: "",
                thmNotifCount: "",
                radio1: '4',
                tableData1: [{
                    YM: this.$t('MonthlyElectricityConsumption') + '(' + this.$t('degree') + ')',
                    Ename1: '52,452',
                    Ename2: '75,895',
                    Ename3: '78,555',
                    Ename4: '12,952',
                }, {
                    YM: this.$t('DailyElectricityConsumption') + '(' + this.$t('degree') + ')',
                    Ename1: '2,485',
                    Ename2: '4,258',
                    Ename3: '4,256',
                    Ename4: '700',
                }],
                tableData2: [{
                    YM: this.$t('MonthlyElectricityConsumption') + '(' + this.$t('degree') + ')',
                    Ename1: '671',
                    Ename2: '195',
                    Ename3: '0',
                    Ename4: '25,789',
                    Ename5: '52,445',
                }, {
                    YM: this.$t('DailyElectricityConsumption') + '(' + this.$t('degree') + ')',
                    Ename1: '29',
                    Ename2: '9',
                    Ename3: '0',
                    Ename4: '181',
                    Ename5: '2,759',
                }],
                ParkSelectoptions: [{
                    value: '1',
                    label: this.$t('JinqiaoHeadquarters')
                }],
                ParkSelectvalue: '1',
                data3:{},
                data6:{},
                data1:{},
                data2:{},
                data4:{},
                lasttotal:0,
                curtatol:0,
                lastavgday :0,
                curday:0,
                formselect: {
                    factoryID: "b9ad27bc-279b-4ac8-8b0a-9843fbd1152f",
                    cityID: "68552254-f8d5-4e3e-a3cb-08d879873f16"
                },
            }


        },
        methods: {
            showDetail(e) {
                // this.dialogBuilding = true
                this.radio1 = e
            },
            toWarning() {
                this.$router.push({
                    name: "/warning_management",
                    params: {
                        value: "b9ad27bc-279b-4ac8-8b0a-9843fbd1152f"
                    }
                })
            },
            getData() {
                var data = {
                    cityId: "",
                    factoryId: "b9ad27bc-279b-4ac8-8b0a-9843fbd1152f",
                }, that = this
                GetNotifCount(data).then(res => {
           
                    that.elcNotifCount = res.result.elcNotifCount
                    that.thmNotifCount = res.result.thmNotifCount
                    let notifcount = parseInt(that.elcNotifCount)+parseInt(that.thmNotifCount)
                    sessionStorage.setItem('notifcount',notifcount);

                })
            },
            getYearMonth(){
                 
                let datestr =''
                let date = new Date()
                let year = date.getFullYear()
                let month = date.getMonth()+1
                if(date.getMonth()>=0&&date.getMonth()<9){
                    datestr = `${year}${0}${month}`

                }else{
                    datestr = `${year}${month}`
                }
                return datestr
            },
            DBRepAPIUrlInfo() {
                var that = this
                var datas = that.formselect;
                GetDBRepAPIUrlInfo().then(res => {
                    if (res.success) {
                        sessionStorage.setItem("Authorization", res.result.token)
                        // odataElectricQuantity().then(res=>{
                        //
                        // })
                        GetElectricQuantityData(datas).then(res => {
                            if (res.success) {
                                 
                                var data = res.result.value
                                data.map(i=>{
                                    if(i.buildName=='B3'&&this.getYearMonth()==i.yearMonth){
                                        that.data3=i
                                    }else if(i.buildName=='B6'&&this.getYearMonth()==i.yearMonth){
                                        that.data6=i
                                    }
                                })

                                that.lasttotal = parseFloat(JSON.stringify(that.data3)=='{}'?0:that.data3.electricQuantityPlan)+parseFloat(JSON.stringify(that.data6)=='{}'?0:that.data6.electricQuantityPlan)
                                that.curtatol = parseFloat(JSON.stringify(that.data3)=='{}'?0:that.data3.electricQuantity)+parseFloat(JSON.stringify(that.data6)=='{}'?0:that.data6.electricQuantity)
                                that.lastavgday = parseFloat(JSON.stringify(that.data3)=='{}'?0:that.data3.avgElectricQuantity)+parseFloat(JSON.stringify(that.data6)=='{}'?0:that.data6.avgElectricQuantity)
                                that.curday = parseFloat(JSON.stringify(that.data3)=='{}'?0:that.data3.current_ElectricQuantity)+parseFloat(JSON.stringify(that.data6)=='{}'?0:that.data6.current_ElectricQuantity)


                            }
                        })
                    }
                }).catch(err => {
                    that.$router.push("login")
                })
            },
        },
        mounted() {
            this.getData()
            //this.DBRepAPIUrlInfo();

        },
        computed: mapState(
            {
            isCollapse: state => state.isCollapse
        })

    }
</script>
<style>
    .el-popover {
        border:0;
        padding:0;
        /*box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0) !important;*/
    }
    h6{
        margin-block-start:1em;
        margin-block-end:1em;
        width: 60%;
        margin: 0 auto;
    }
</style>
<style scoped>

    .el-main {
        padding: 0;
    }

    .el-dialog-div {
        height: 60vh;
        overflow: auto;
    }
</style>
